import { Check } from "lucide-react";
import { useGroups } from "@/hooks/useDirectory";
import { GroupIcon } from "@/components/common/Visuals";
import { chipStyle } from "@/lib/format";
import { cn } from "@/lib/utils";

export function GroupPicker({ kinds = ["clubs", "commissions", "groupes"], value, onChange, testId }) {
  const { data } = useGroups();
  const options = kinds.flatMap((k) => data?.[k] || []).filter((g) => g.active || value.includes(g.id));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  if (!options.length) return <p className="text-sm text-muted-foreground">Aucun élément disponible.</p>;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((g) => {
        const on = value.includes(g.id);
        return (
          <button
            type="button"
            key={g.id}
            onClick={() => toggle(g.id)}
            data-testid={`${testId}-option-${g.id}`}
            aria-pressed={on}
            style={on ? chipStyle(g.color || "#A4247F") : undefined}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition-[background-color,border-color,color]",
              on ? "" : "border-border bg-white text-stone-600 hover:border-stone-300",
            )}
          >
            {on ? <Check className="h-3.5 w-3.5" /> : <GroupIcon group={g} className="h-3.5 w-3.5" />}
            {g.name}
          </button>
        );
      })}
    </div>
  );
}
